import React, { FC, ReactNode } from 'react';
import { Field } from 'react-final-form';

import { Stack, StackProps, Typography } from 'Modules/ui3';
import { CheckboxField } from 'Modules/core/forms';


export interface CheckboxGroupFieldProps extends Omit<StackProps, 'title'> {
    title: ReactNode;
    options: {
        name: string;
        label: ReactNode;
    }[];
}

export const CheckboxGroupField: FC<CheckboxGroupFieldProps> = ({ options, title, ...props }) => (
    <Stack spacing={3} width='fit-content' {...props}>
        <Typography color='grayscale.shade85' variant='regularCaption1'>
            {title}
        </Typography>

        {options.map(({ name, label }, index) => (
            <Field
                type='checkbox'
                key={index}
                name={name}
                component={CheckboxField}
                label={label}
                typographyProps={{
                    color: 'grayscale.shade95',
                    variant: 'regularBody2',
                }}
            />
        ))}
    </Stack>
);
